module.exports = __webpack_public_path__ + "static/cloud-infrastructure-61c1ab3878274cd5739353974ee576f5.jpg";